module.exports = __webpack_public_path__ + "img/w3_percent_dark.b6603da6.png";